import Vue from 'vue';
import Vuelidate from 'vuelidate';
import { required, minLength, email } from 'vuelidate/lib/validators'; // External SVG sprite for IE9-12

Vue.use(Vuelidate);

/**
 * Get current window width
 *
 * @return {number} Current width of Window.
 */

function getWidth() {
  return window.innerWidth > 0 ? window.innerWidth : window.screen.width;
}

/**
 * Search Button
 *
 * @description
 *   Toggling css classes on Search button, <header> and search input.
 * @vue-data {boolean} isActive - Default state of button.
 * @vue-event {function} displaySearch - Show/hide search form via toggling css
 *   classes and get focus.
 */

/* const search = new Vue({ // eslint-disable-line no-unused-vars
  el  : '#c-search--button',
  data: {
    hasSearch: false,
  },
  methods: {
    displaySearch: function searchToggler() {
      const header = document.querySelector('#c-header');
      const input = document.querySelector('#c-search__input');
      this.hasSearch = !this.hasSearch;

      if (this.hasSearch === true) {
        header.classList.add('has-search');
        input.focus();
      }

      else {
        header.classList.remove('has-search');
        input.blur();
      }
    },
  },
}); */

/**
 * Expandable Text
 *
 * @description Toggling css classes on More/Less buttons.
 * @vue-data {boolean} isExpanded - Default state of button.
 * @vue-event {function} textExpander - Show/hide more text via toggling css
 */

const expandButton = document.querySelector('#c-button--expand');
if (expandButton) {
  // eslint-disable-next-line no-unused-vars
  const expandable = new Vue({
    el: '#c-button--expand',
    data: {
      isExpanded: false
    },
    methods: {
      textExpander: function textExpandToggler() {
        const fullText = document.querySelector('.is-expandable');
        this.isExpanded = !this.isExpanded;

        if (this.isExpanded === true) {
          fullText.classList.add('is-expanded');
        } else {
          fullText.classList.remove('is-expanded');
        }
      }
    }
  });
}

/**
 * Hamburger Button
 *
 * @description Toggling css classes on Hamburger button and <header>.
 * @vue-data {boolean} isActive - Default state of button.
 * @vue-event {function} displayMenu - Show/hide <header> via toggling css
 *   classes.
 */

// eslint-disable-next-line no-unused-vars
const hamburger = new Vue({
  el: '#c-hamburger',
  data: {
    isActive: false
  },
  methods: {
    displayMenu: function stateToggler() {
      const header = document.querySelector('#c-header');
      this.isActive = !this.isActive;

      if (this.isActive === true) {
        header.classList.add('is-active');
      } else {
        header.classList.remove('is-active');
        // header.classList.remove('has-search');
        // search.hasSearch = false;
      }
    }
  }
});

/**
 * Sticky
 */

const header = document.querySelector('#c-header');

/**
 * Sticky hamburger
 *
 * @description
 *   Above 992px window width and if we scroll below header the
 *   sticky Hamburger button appears at top right corner. We achieve this via
 *   toggling css classes on <body.>
 */

function stickyHamburger() {
  const heightOfHeader = header.offsetHeight;

  if (getWidth() >= 992 && window.scrollY >= heightOfHeader) {
    document.body.classList.add('c-hamburger-is-fixed');
  } else {
    document.body.classList.remove('c-hamburger-is-fixed');
  }
}

window.addEventListener('load', stickyHamburger);
window.addEventListener('scroll', stickyHamburger);
window.addEventListener('resize', stickyHamburger);

/**
 * Blog entry scripts
 *
 * @description
 *   CTA button in different DOM position for mobile and desktop.
 */

const entry = document.querySelector('.js-entry');
if (entry) {
  // eslint-disable-next-line no-unused-vars
  const entryScripts = new Vue({
    el: '.js-entry',
    data: () => ({
      isMobile: false
    }),

    beforeDestroy() {
      if (typeof window !== 'undefined') {
        window.removeEventListener('resize', this.onResize, { passive: true });
      }
    },

    mounted() {
      this.onResize();
      window.addEventListener('resize', this.onResize, { passive: true });
    },

    methods: {
      onResize() {
        this.isMobile = window.innerWidth < 768;
      }
    }
  });
}

/**
 * Contact Form validation
 *
 * @description Validate form fields with Vuelidate.
 * @vue-data {string} priority - Default value of Priority radio button filed.
 * @vue-data {string} name - Default value of Name text filed.
 * @vue-data {string} email - Default value of Email filed.
 * @vue-data {string} message - Default value of Message textarea filed.
 * @vue-validation {object} priority - Required validations for Priority field.
 * @vue-validation {object} name - Required validations for Name field.
 * @vue-validation {object} email - Required validations for Email field.
 * @vue-validation {object} message - Required validations for Message field.
 * @vue-event {function} priority - Validate given value of Priority field.
 * @vue-event {function} name - Validate given value of Name field.
 * @vue-event {function} email - Validate given value of Email field.
 * @vue-event {function} message - Validate given value of Message field.
 */

const contactForm = document.querySelector('#c-form--contact');
if (contactForm) {
  // eslint-disable-next-line no-unused-vars
  const contactValidation = new Vue({
    el: '#c-form--contact',
    delimiters: ['[[', ']]'],
    data: {
      priority: '',
      name: '',
      email: '',
      message: '',
      submitStatus: null
    },
    validations: {
      priority: {
        required
      },
      name: {
        required,
        minLength: minLength(3)
      },
      email: {
        required,
        email
      },
      message: {
        required,
        minLength: minLength(5)
      }
    },

    methods: {
      setPriority(value) {
        this.priority = value;
        this.$v.priority.$touch();
      },
      setName(value) {
        this.name = value;
        this.$v.name.$touch();
      },
      setEmail(value) {
        this.email = value;
        this.$v.email.$touch();
      },
      setMessage(value) {
        this.message = value;
        this.$v.message.$touch();
      },
      submit() {
        this.$v.$touch();
      }
    }
  });
}
